var render = function render(){var _vm=this,_c=_vm._self._c;return _c('diverse-input',_vm._b({ref:"di",attrs:{"value":_vm.localValue,"config":_vm.config},on:{"update:value":function($event){_vm.localValue=$event},"enter":_vm.emitEnterEvent}},'diverse-input',_vm.$attrs,false))
}
var staticRenderFns = []

export { render, staticRenderFns }